/* ================================================== */
/* FLICKITY > Medias
/* ================================================== */

var $previousVideo = null;

function mediaGallery(item) {
	var $gallery = $(item);

	if ($gallery.length) {

		// Init active
		$active = $('.active', $gallery).flickity({
			cellSelector   : '.active__item',
			adaptiveHeight : (item == '#photos') ? false : true,
			imagesLoaded   : true,
			freeScroll     : false,
			autoPlay       : false,
			wrapAround     : (item == '#videos') ? false : true,
			draggable      : (item == '#videos') ? true : true,
			prevNextButtons: (item == '#videos') ? false : true,
			pageDots       : false,
			arrowShape     : 'M71.988 0a6.237 6.237 0 0 0-4.421 1.834L23.829 45.58a6.255 6.255 0 0 0 0 8.839L67.567 98.17a6.258 6.258 0 0 0 8.842 0 6.255 6.255 0 0 0 0-8.84L37.086 50.003l39.323-39.33A6.255 6.255 0 0 0 71.988 0z'
		});

		// Init thumbnails
		var $thumbnails = $('.thumbnails', $gallery).flickity({
			asNavFor       : item + ' .active',
			cellSelector   : '.thumbnails__item',
			setGallerySize : false,
			imagesLoaded   : true,
			freeScroll     : false,
			autoPlay       : false,
			adaptiveHeight : false,
			pageDots       : false,
			prevNextButtons: false,
			accessibility  : false
		});

		// Load
		$('.active, .thumbnails', $gallery).addClass('loaded');

		// Refresh flickity on tab change
		$('[data-toggle="tab"]').click(function() {
			if ($gallery.hasClass('active')) {
				setTimeout(function() {
					$active.flickity('resize');
				}, 400);
			}
		});

		// Scroll to media
		$('a', $gallery).click(function() {
			if (breakpointXs) {
				$('html, body').stop().animate({ scrollTop: $('.medias__tabs').offset().top - $('.navbar-header').outerHeight() + 1 });
			} else {
				$('html, body').stop().animate({ scrollTop: $('.medias__tabs').offset().top - $('#navbar').outerHeight() + 1 });
			}
		});

		// Accessibility
		$('.active .active__item.is-selected', $gallery).attr('tabindex', '0');
		$('.active .active__item:not(.is-selected)', $gallery).attr('tabindex', '-1');

		$active.on('select.flickity', function() {
			$('.active .active__item.is-selected', $gallery).attr('tabindex', '0');
			$('.active .active__item:not(.is-selected)', $gallery).attr('tabindex', '-1');
		});

		// Videos
		if (item == '#videos') {

			// Autoplay on thumb click
			$('a', $thumbnails).click(function() {
				var index    = $(this).data('index'),
					$iframe  = $('.active__item[data-index="' + index + '"]', item).find('iframe');

				if (typeof $iframe.attr('data-src') !== undefined) {
					var srcPause = $iframe.attr('data-src').replace('&autoplay=1', '').replace('&autoplay=0', '');
				} else if (typeof $iframe.hasAttr('src') !== undefined) {
					var srcPause = $iframe.attr('src').replace('&autoplay=1', '').replace('&autoplay=0', '');
				}

				var srcPlay  = srcPause + '&autoplay=1';

				if ($previousVideo !== null) {
					if (typeof $iframe.attr('data-src') !== undefined) {
						$previousVideo.attr('data-src', $previousVideo.attr('data-src').replace('&autoplay=1', '&autoplay=0'));
					} else if (typeof $iframe.attr('src') !== undefined) {
						$previousVideo.attr('src', $previousVideo.attr('src').replace('&autoplay=1', '&autoplay=0'));
					}
				}

				setTimeout(function() {
					$iframe.attr('src', srcPlay);
				}, 1000);
				$previousVideo = $iframe;
			});

			// Stop on tab change
			$('.medias__nav li:not(.active) a').click(function() {
				if ($(item).hasClass('active') && $previousVideo !== null) {
					$previousVideo.attr('src', $previousVideo.attr('src').replace('&autoplay=1', ''));
				}
			});

		// Photos
		} else if (item == '#photos') {

			// Refresh on image load
			$('.active', $gallery).imagesLoaded().progress(function(instance, image) {
				$active.flickity('resize');
			});

		}

	}
}

$(document).ready(function() {
	mediaGallery('#videos');
	mediaGallery('#photos');
});